module.exports = __webpack_public_path__ + "static/media/welcome_page_full.78bc6a00.png";